import React from 'react'
import { Wrapper } from 'modules/Roles/ViewRole/CandidatesTable/CandidateFilter/Styles/style'
import Tree from 'components/Tree'

const DegreeAndDepartmentFilter = ({
  degreeListData,
  checkedKeys,
  setCheckedKeys,
  setCheckedIds,
}) => {
  const onCheck = (activeKeys, info) => {
    setCheckedKeys(activeKeys)

    let activeIds = info?.checkedNodes
      ?.filter(item => !item?.hasOwnProperty('children'))
      ?.map(id => id?.value)

    setCheckedIds(activeIds)
  }

  return (
    <Wrapper column>
      <Tree
        treeData={degreeListData}
        checkedKeys={checkedKeys}
        onCheck={onCheck}
      />
    </Wrapper>
  )
}

export default DegreeAndDepartmentFilter
